<div id="loginComponent" [ngStyle]="{backgroundImage:'url(./assets/images/cacesa-img.svg )'}">
    <div class="container h-100">
        <div class="row justify-content-center h-100">

            <div class="col-4"></div>
            <div class="col-4">
                <div class="card loginContent">
                    <img src="assets/images/cacesa.svg" alt="logo" class="logoImg">
                    <div class="card-body">
                        <h5 class="card-title text-center">{{ 'login.title' | translate }}!</h5>
                        <h6 class="card-subtitle text-center">{{ 'login.subtitle' | translate }}</h6>
                        <form class="formLogin" [formGroup]="form" (ngSubmit)="onSubmit()">
                            <div class="form-group mb-3">
                                <input type="text" class="form-control userInput" formControlName="userName"
                                    placeholder="{{ 'login.user' | translate }}" [ngClass]="{ 'is-invalid': submitted && f.userName.errors }">
                                <div *ngIf="submitted && f.userName.errors" class="invalid-feedback">
                                    <div *ngIf="f.userName.errors.required">User is required</div>
                                    <div *ngIf="f.userName.errors.userName">User is invalid</div>
                                </div>
                            </div>
                            <div class="form-group mb-3">
                                <div class="input-group passwordInput">
                                    <input [type]="fieldTextType ? 'text' : 'password'" placeholder="{{ 'login.password' | translate }}" class="form-control passwordFile"
                                        formControlName="password"
                                        [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                                    <button class="btn btn-eye" type="button" (click)="toggleFieldTextType()"> <i
                                            [ngClass]="{'icon-eye-close': !fieldTextType,  'icon-eye': fieldTextType }"></i></button>
                                </div>
                                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                    <div *ngIf="f.password.errors.required">Password is required</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <button type="submit" class="btn btn-login btn-primary" [disabled]="!form.valid">{{ 'login.login' | translate }}</button>
                            </div>
                        </form>
                        <p class="text-center blockquote">{{ 'login.forgotPassword' | translate }}
                        </p>
                    </div>
                </div>

            </div>
            <div class="col-4"></div>
        </div>
    </div>
</div>